import { modals } from 'presentation/main/modals/modals'
import { PropertyDetailReportModal } from './PropertyDetailReportModal'

modals.register('PROPERTY_DETAIL_REPORT_MODAL', PropertyDetailReportModal)
